// $(function(){
//   var headerHeight = $('header').outerHeight(); // ヘッダーについているID、クラス名など、余白を開けたい場合は + 10を追記する。
//   var urlHash = location.hash; // ハッシュ値があればページ内スクロール
//   if(urlHash) { // 外部リンクからのクリック時
//     $('body,html').stop().scrollTop(0); // スクロールを0に戻す
//     setTimeout(function(){ // ロード時の処理を待ち、時間差でスクロール実行
//       var target = $(urlHash);
//       var position = target.offset().top - headerHeight;
//       $('body,html').stop().animate({scrollTop:position}, 1000); // スクロール速度ミリ秒
//     }, 100);
//   }
//   $('a[href^="#"]').click(function(){ // 通常のクリック時
//     var href= $(this).attr("href"); // ページ内リンク先を取得
//     var target = $(href);
//     var position = target.offset().top - headerHeight;
//     $('body,html').stop().animate({scrollTop:position}, 1000); // スクロール速度ミリ秒
//     return false; // #付与なし、付与したい場合は、true
//   });
// });

$(function(){
  $(window).scroll(function(){
    var obj = $('.sizing');
    scroll = $(window).scrollTop();
    if (scroll > 1) {
      obj.addClass('headerScroll');
    } else{
      obj.removeClass('headerScroll');
    }
  })
});

$(document).ready(spinButton);
$(window).resize(spinButton);

function spinButton(){
  $('.spinButton').each(function(){
    var buttonWidth = $(this).width(),
        buttonHeight = $(this).height(),
        gradSize = buttonWidth + 100,
        topOffest = (gradSize / 2) - (buttonHeight * 2);
    $(this).children('.gradient').width(gradSize).height(gradSize).css({'top': - topOffest});
  });
}

// $('.slide').slick({
//   autoplay: true,
//   autoplaySpeed: 0,
//   speed: 5000,
//   cssEase: "linear",
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   pauseOnFocus: false,
//   pauseOnHover: false,
//   responsive: [
//     {
//       breakpoint: 751,
//       settings: {
//         slidesToShow: 2,
//       }
//     }
//   ]
// });


//関連コンテンツ、スライド
// $('.slider').slick({
//   autoplay:true,
//   autoplaySpeed:5000,
//   dots: false,
//   rows: 2,
//   slidesPerRow: 2,
//   responsive: [
//     {
//       breakpoint: 751,
//       settings: {
//         rows: 4,
//         slidesPerRow: 1,
//       }
//     }
//   ]
// });

// $("header .menu_first_level a").on("click", function() {
//   $(this).next().slideToggle();
//   if ($(this).hasClass('active')) {
//     $(this).removeClass('active');
//   }
//   else {
//     $(this).addClass('active');
//   }
// });

// $(function(){
//   $("header .btn-trigger").on("click", function() {
//     $(this).next().slideToggle();
//   });
//   $('.close-btn').click(function() {
//     $(this).parent().prev().toggleClass('selected');
//     $(this).parent().slideToggle();
//   });
// });

// $("header .sub a").on("click", function() {
//   $(this).next().slideToggle();
//   if ($(this).hasClass('active')) {
//     $(this).removeClass('active');
//   }
//   else {
//     $(this).addClass('active');
//   }
// });

// $(function () {
//   $('.accordion_name').click(function() {
//     $(this).next('.accordion_box').slideToggle('fast');
//   });
//   $('.accordion_list').click(function(e) {
//     $(this).children('.accordion_box').slideToggle('fast');
//     e.stopPropagation();
//   });
//   $('h5').on('click', function () {
//     $(this).toggleClass('open', 200);
//   });
// });

$(function() {
  $('.btn-0')
    .on('mouseenter', function(e) {
      var parentOffset = $(this).offset(),
          relX = e.pageX - parentOffset.left,
          relY = e.pageY - parentOffset.top;
      $(this).find('span').css({top:relY, left:relX})
    })
    .on('mouseout', function(e) {
      var parentOffset = $(this).offset(),
          relX = e.pageX - parentOffset.left,
          relY = e.pageY - parentOffset.top;
      $(this).find('span').css({top:relY, left:relX})
    });
  $('[href="#"]').click(function(){return false});
});

// //要素高さ調整関数 elms:比較する要素 columns:列の数
// function listHeight(elms,columns) {
// 	//要素の高さをリセット
// 	$(elms).css('height', '');
// 	//設定された列の数が1以下だった場合は処理を停止
// 	if(columns <= 1) {
// 		return false;
// 	}
// 	//該当する要素の数を取得
// 	var liLen = $(elms).length;
// 	//各要素の高さの配列
// 	var liHiArr = [];
// 	//行の高さの配列
// 	var lineHiArr = [];
// 	var i;
// 	//要素の高さを取得
// 	for (i = 0; i <= liLen; i++) {
// 		liHiArr[i] = $(elms).eq(i).height();
// 		if (lineHiArr.length <= Math.floor(i / columns)
// 			|| lineHiArr[Math.floor(i / columns)] < liHiArr[i]) {
// 			lineHiArr[Math.floor(i / columns)] = liHiArr[i];
// 		}
// 	}
//
// 	//要素の高さを変更
// 	$(elms).each(function(i){
// 		$(this).css('height',lineHiArr[Math.floor(i / columns)] + 'px');
// 	});
// }
//
// //使用例
// var listElms = '.common_introduction-list > li > a';
// listHeight (listElms,3);
